import { ThemeProviderInterface, SemanticsExtended } from '@veneer/theme';
import { UiTheme } from '../../config/constants';

export const hpxTokens = {
  manatee0: '#FDFDFF',
  manatee1: '#F5F6FF',
  manatee2: '#EDEEFE',
  manatee3: '#E0E1EE',
  manatee4: '#D1D2E4',
  manatee5: '#B5B7CB',
  manatee6: '#9B9CB1',
  manatee7: '#828398',
  manatee8: '#696B7E',
  manatee9: '#525365',
  manatee10: '#3C3D4B',
  manatee11: '#292A35',
  manatee12: '#191A22'
};

export const getThemeProviderConfig = (
  uiBrand = UiTheme.hpsmart,
  hpxTheme: SemanticsExtended
): ThemeProviderInterface => {
  let config: ThemeProviderInterface = {
    customSemantics: undefined,
    mode: 'light',
    shape: 'round',
    density: 'standard'
  };

  if (uiBrand === UiTheme.hpx) {
    config = {
      customSemantics: hpxTheme,
      mode: 'light',
      shape: 'pill',
      density: 'standard'
    };
  }

  return config;
};
